import {
  BATTERY_SUBTYPE,
  CHARGER_SUBTYPE,
  DOME_SUBTYPE,
  EAR_MOLD_SUBTYPE,
  OTHER_SUBTYPE,
  RECEIVER_SUBTYPE,
  REMOTE_SUBTYPE,
  TUBE_SUBTYPE
} from "constants/products";
import {
  ACCESSORY_PRODUCT_TYPE,
  COCHLEAR_IMPLANT_PRODUCT_TYPE,
  HEARING_AID_PRODUCT_TYPE,
  SUPPLY_PRODUCT_TYPE
} from "constants/sales";
import EnumDataSource from "utils/enum-data-source.util";

// The stockable subset of ProductType — services and fees are never inventory.
// Cochlear implants were missing, so editing one rendered an empty required Type
// select that could not be saved without changing the product's type.
const inventoryProductTypes = {
  [HEARING_AID_PRODUCT_TYPE]: "Hearing Aid",
  [COCHLEAR_IMPLANT_PRODUCT_TYPE]: "Cochlear Implant",
  [ACCESSORY_PRODUCT_TYPE]: "Accessory",
  [SUPPLY_PRODUCT_TYPE]: "Supply"
};

export const INVENTORY_PRODUCT_TYPES = new EnumDataSource(
  inventoryProductTypes
);

// Accessory is the only stockable type with subtypes — hearing aids, cochlear
// implants and supplies carry none (see add-master-product-form, which clears
// subtype for exactly those).
//
// This existed as three separate `[HEARING_AID, SUPPLY].includes(type)` allowlists
// (the Product field gate, the Subtype field gate and the Subtype validator). Each
// one silently excluded Cochlear Implant, so editing one hid the Product picker and
// demanded a Subtype it does not have. One predicate so they cannot drift apart.
export const productTypeHasSubtype = (type?: number | string | null) =>
  Number(type) === ACCESSORY_PRODUCT_TYPE;

const inventoryProductSubTypes = {
  [RECEIVER_SUBTYPE]: "Receiver",
  [EAR_MOLD_SUBTYPE]: "Earmold",
  [TUBE_SUBTYPE]: "Tube",
  [DOME_SUBTYPE]: "Dome",
  [BATTERY_SUBTYPE]: "Battery",
  [CHARGER_SUBTYPE]: "Charger",
  [REMOTE_SUBTYPE]: "Remote",
  [OTHER_SUBTYPE]: "Other"
};

export const INVENTORY_PRODUCT_SUB_TYPES = new EnumDataSource(
  inventoryProductSubTypes
);
